import { Component, Inject, Optional, Input, ElementRef, ViewChild } from '@angular/core';
import { PershingTranslationService, IAppDataStore } from '@pershing/pershing-core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { ExchangeAgreementConfirmLaterDialogComponent } from '../ExchangeAgreementConfirmlaterDialog/exchange-agreement-confirmlater-dialog.component';
import { TradingService, TradingEntitlements } from '@pershing/trading-common';

@Component({
    selector: 'exchange-agreement-nps',
    templateUrl: './exchange-agreement-npsd.component.html'
})
export class ExchangeAgreementNonProfDisclosureComponent {
    @Input() platform: string;
    @Input() public tradingEntitlements: TradingEntitlements = null;
    @ViewChild('scrollToTop', { read: ElementRef }) public scroll: ElementRef<any>;

    nspdValue: any;
    btnflag: boolean = true;
    usermismatchProf: any;
    usermismatchNonprof: any;
    serverError: boolean = false;
    ibdName: string;
    errorMsg: string;
    deviceType: string = 'desktop';
    constructor(
        private translationService: PershingTranslationService, private dialog: MatDialog,
        private appDataStore: IAppDataStore, private tradingService: TradingService,
        @Optional() @Inject('AppSettings') appSettings: any) {
//        let parsemap = appSettings.ibdConfigMap;
//        this.ibdName = parsemap.ibdName;
        // TODO find out how to get IBD number?
        this.ibdName = '';
        if (!!appSettings.deviceType) {
            this.deviceType = appSettings.deviceType;
        }
    }

    showCancelDialog(): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.minWidth = '250px';
        dialogConfig.disableClose = true;
        this.dialog.open(ExchangeAgreementConfirmLaterDialogComponent, dialogConfig);
    }
    nonProfDisclosure() {       
            if (this.nspdValue === 'P') {
                this.tradingService.setExchangeAgreementDialogState('exchangenysep');
            } else if (this.nspdValue === 'N') {
                this.tradingService.setExchangeAgreementDialogState('exchangenysenp');
            }
    }
    userMismatchCheck()
    {
        this.errorMsg = '';
        window.scrollTo(0, 0);
        this.usermismatchProf = this.tradingEntitlements.professionalUserIndicator === 'P' && this.nspdValue === 'N';
        this.errorMsg = this.translationService.translate.instant('EXCHANGE_AGREEMENT.ERRORUSERMISMATCHPROF', { value: this.ibdName });
       if(this.usermismatchProf) {
           this.btnflag = true;
           this.scroll.nativeElement.scrollIntoView();
       } else {
           this.btnflag = false;
       }
    }
    onChange(profChange: MatRadioChange) {
        console.log('profChange', profChange.value);
        this.nspdValue = profChange.value;
        this.setRadioValue();
        console.log('values checking...', this.appDataStore.get('NPSDDATA'));
        this.userMismatchCheck();
    }
    setRadioValue() {
        console.log(this.nspdValue);
        if (this.nspdValue === 'P') {
            let prof = { professional: true };
            this.appDataStore.put('NPSDDATA', prof);
        }
        if (this.nspdValue === 'N') {
            let nonProf = { professional: false };
            this.appDataStore.put('NPSDDATA', nonProf);
        }
    }
}
